import getCasTableCellValue from '../getCasTableCellValue';
import ICasRenderCellProps from '../ICasRenderCellProps';

export function CasRenderArrayAsCSV(props: ICasRenderCellProps) {
  return getCasTableCellValue(props)?.map((item: string) => item).join(', ');
}